<template>
    <el-card>
    <template v-slot:header>
      <div class="clearfix">
        <span style="font-weight: bold;"><i class="el-icon-pie-chart" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Proportion of SEs and TEs</span>
      </div>
    </template>
    <el-container>
      <el-main>
        <div id="issuper" style="width:100%;height:500px;"></div>
      </el-main>
    </el-container>
  </el-card>  
  </template>
  
  <script>
  export default {
    props: {
      species: {
        type: String,
        required: true
      },
      tissue: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        chartData: [],
        url: "http://183.175.59.4/devenhancer/",// 后端接口地址
      };
    },
    mounted() {
      this.handleAnalysis();
    },
    methods: {
      handleAnalysis() {
        // 发送请求获取后端数据
        const params = { Species: this.species, Tissue: this.tissue };
        this.$axios.get(this.url + "telist" + "/", { params }).then((response) => {
            // 对数据进行处理
            const data = response.data;
            if (data && Array.isArray(data) && data.length > 0) {
                let count = {
                    '0': 0,
                    '1': 0
                };
            for (let item of data) {
                if (item['isSuper'] !== undefined) {
                count[item['isSuper']]++;
                }
            }
            // 将 count 中的数据转换为饼图所需的格式
            const seriesData = [];
            for (let prop in count) {
              seriesData.push({
                name: prop === '0' ? 'TE' : 'SE',
                value: count[prop]
              })
            }
            // 绘制饼图
            const chart = this.$echarts.init(document.getElementById('issuper'));
            chart.setOption({
              title: {
                left: 'center'
              },
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)'
              },
              legend: {
                // type: 'scroll', // 图例超出容器时启用滚动
                right: '10%', // 图例在容器右侧偏移 10%
                orient: 'horizontal', // vertical是垂直布局
                align: 'left', // 左对齐
                itemWidth: 20, // 控制每个图例项的宽度
                itemGap: 10, // 控制每个图例项之间的间距
              },
              series: [
                {
                  name: 'issuper',
                  type: 'pie',
                  radius: ['0%', '70%'],
                  avoidLabelOverlap: false,
                  label: {
                    show: true,
                    fontSize: 14,
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontSize: '20',
                      fontWeight: 'bold'
                    }
                  },
                  labelLine: {
                    show: true,
                  },
                  data: seriesData
                }
              ]
            });
            
          } else {
            this.$message.warning('No data found.');
          }
      }).catch(err => {
          console.error(err);
          this.$message.error('Failed to fetch data.');
        });
      }
   }
  }
  </script>


// WEBPACK FOOTER //
// src/components/teAnalysis/Issuper.vue